import React from "react";
import { BiBuildingHouse, BiCar, BiPackage, BiWalk } from "react-icons/bi";
import { BsCalculatorFill, BsFillPersonBadgeFill } from "react-icons/bs";
import {
  FaBox,
  FaBoxes,
  FaChargingStation,
  FaCity,
  FaDoorClosed,
  FaDropbox,
  FaFlag,
  FaLaptop,
  FaMapSigns,
  FaPaperclip,
  FaPersonBooth,
  FaRunning,
  FaTruck,
  FaTruckLoading,
  FaTruckMoving,
  FaTshirt,
  FaWarehouse,
  FaWater,
} from "react-icons/fa";
import {
  RiAccountBoxFill,
  RiAccountCircleFill,
  RiBankFill,
  RiMap2Fill,
  RiRoadMapFill,
  RiOrganizationChart,
} from "react-icons/ri";
import { GiInjustice, GiNuclearWaste } from "react-icons/gi";
import { MdFastfood, MdManageAccounts, MdSwitchAccount } from "react-icons/md";
import {
  AiOutlineApartment,
  AiOutlineCluster,
  AiOutlineDeploymentUnit,
  AiOutlineMedicineBox,
  AiOutlineProfile,
} from "react-icons/ai";
import { GrCalendar, GrCluster } from "react-icons/gr";

import { useNavigate } from "react-router-dom";

import { Colors } from "../../assets/Colors";

const MasterPage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  let GeneralAuth = false;
  let HRD = false;
  let Account = false;
  let Operational = false;
  let ListActivity = false;
  let Inventory = false;
  let Equipment = false;

  if (
    user.Otoritas.MKelompok !== 0 ||
    user.Otoritas.MSatuan !== 0 ||
    user.Otoritas.UserPC !== 0 ||
    user.Otoritas.MFranco !== 0 ||
    user.Otoritas.MBarang !== 0 ||
    user.Otoritas.MActivity !== 0 ||
    user.Otoritas.MSupplier !== 0
  ) {
    Inventory = true;
  }
  if (
    user.Otoritas.MBisnisUnit !== 0 ||
    user.Otoritas.MNegara !== 0 ||
    user.Otoritas.MProvinsi !== 0 ||
    user.Otoritas.MKota !== 0 ||
    user.Otoritas.MBank !== 0 ||
    user.Otoritas.MKlien !== 0 ||
    user.Otoritas.MKendaraan !== 0 ||
    user.Otoritas.MKelompokKegiatan !== 0 ||
    user.Otoritas.MDesa !== 0
  ) {
    GeneralAuth = true;
  }
  if (
    user.Otoritas.MBagian !== 0 ||
    user.Otoritas.MCuti !== 0 ||
    user.Otoritas.MPenyakit !== 0 ||
    user.Otoritas.MGolongan !== 0 ||
    user.Otoritas.MTipeKaryawan !== 0 ||
    user.Otoritas.MJabatan !== 0 ||
    (user.Otoritas.MStrukturOrganisasi ?? 0) !== 0 ||
    user.Otoritas.MLokasiTugas !== 0 ||
    user.Otoritas.MPayroll !== 0
  ) {
    HRD = true;
  }

  if (
    user.Otoritas.MLabour !== 0 ||
    user.Otoritas.MWasteManagement !== 0 ||
    user.Otoritas.MCargoCarryingUnit !== 0 ||
    user.Otoritas.MAreaRental !== 0 ||
    user.Otoritas.MRental !== 0
  ) {
    ListActivity = true;
  }

  if (
    user.Otoritas.MMainAccount !== 0 ||
    user.Otoritas.MSubAccount !== 0 ||
    user.Otoritas.MSubGroupAccount !== 0 ||
    user.Otoritas.MDetailAccount !== 0
  ) {
    Account = true;
  }

  if (user.Otoritas.MEquipment !== 0) {
    Equipment = true;
  }

  if (
    user.Otoritas.MCustomer !== 0 ||
    user.Otoritas.MOum !== 0 ||
    user.Otoritas.MGudang !== 0 ||
    user.Otoritas.MLimbah !== 0 ||
    user.Otoritas.MKemasan !== 0 ||
    user.Otoritas.MKendaraan !== 0 ||
    user.Otoritas.MJetty !== 0 ||
    user.Otoritas.MRoom !== 0 ||
    user.Otoritas.MMeals !== 0 ||
    user.Otoritas.MTypeOfClothing !== 0 ||
    user.Otoritas.MFuel !== 0 ||
    user.Otoritas.MLocationUsed !== 0 ||
    user.Otoritas.MGeneralServiceUnit !== 0 ||
    (user.Otoritas.MDestination !== 0) | (user.Otoritas.MRentalUnit !== 0)
  ) {
    Operational = true;
  }

  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        {GeneralAuth && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="pl-5 text-white font-bold text-lg">General</div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MBisnisUnit !== 0 && (
                  <div
                    onClick={() => navigate("/master-bisnis-unit")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BiBuildingHouse />
                      <p className="pl-2">Bisnis Unit</p>
                    </div>
                  </div>
                )}

                {user.Otoritas.MNegara !== 0 && (
                  <div
                    onClick={() => navigate("/master-negara")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaFlag />
                      <p className="pl-2">Negara</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MProvinsi !== 0 && (
                  <div
                    onClick={() => navigate("/master-provinsi")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <RiMap2Fill />
                      <p className="pl-2">Provinsi</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MKota !== 0 && (
                  <div
                    onClick={() => navigate("/master-kotamadya-atau-kabupaten")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaCity />
                      <p className="pl-2">Kota atau Kabupaten</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MBank !== 0 && (
                  <div
                    onClick={() => navigate("/master-bank")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <RiBankFill />
                      <p className="pl-2">Bank</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MKlien !== 0 && (
                  <div
                    onClick={() => navigate("/master-klien")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BiBuildingHouse />
                      <p className="pl-2">Klien</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MKendaraan !== 0 && (
                  <div
                    onClick={() => navigate("/master/kendaraan")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BiCar />
                      <p className="pl-2">Kendaraan</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MKelompokKegiatan !== 0 && (
                  <div
                    onClick={() => navigate("/master/kelompok-kegiatan")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BiWalk />
                      <p className="pl-2">Kelompok Kegiatan</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MDesa !== 0 && (
                  <div
                    onClick={() => navigate("/master/desa")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BiBuildingHouse />
                      <p className="pl-2">Desa</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {HRD && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="pl-5 text-white font-bold text-lg">HRD</div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MLokasiTugas !== 0 && (
                  <div
                    onClick={() => navigate("/master-lokasi-tugas")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <RiRoadMapFill />
                      <p className="pl-2">Lokasi Tugas</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MBagian !== 0 && (
                  <div
                    onClick={() => navigate("/master-bagian")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <GrCluster />
                      <p className="pl-2">Bagian</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MCuti !== 0 && (
                  <>
                    <div
                      onClick={() => navigate("/master-cuti")}
                      className="w-full md:w-1/4 cursor-pointer"
                    >
                      <div
                        style={{ borderColor: Colors.primary }}
                        className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                      >
                        <GrCalendar />
                        <p className="pl-2">Cuti</p>
                      </div>
                    </div>
                    <div
                      onClick={() => navigate("/master-tanggal-merah")}
                      className="w-full md:w-1/4 cursor-pointer"
                    >
                      <div
                        style={{ borderColor: Colors.primary }}
                        className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                      >
                        <GrCalendar />
                        <p className="pl-2">Hari Libur</p>
                      </div>
                    </div>
                  </>
                )}
                {user.Otoritas.MPenyakit !== 0 && (
                  <div
                    onClick={() => navigate("/master-penyakit")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <AiOutlineMedicineBox />
                      <p className="pl-2">Penyakit</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MGolongan !== 0 && (
                  <div
                    onClick={() => navigate("/master-golongan")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <AiOutlineCluster />
                      <p className="pl-2">Golongan</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MTipeKaryawan !== 0 && (
                  <div
                    onClick={() => navigate("/master-tipe-karyawan")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <AiOutlineDeploymentUnit />
                      <p className="pl-2">Tipe Karyawan</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MJabatan !== 0 && (
                  <div
                    onClick={() => navigate("/master-jabatan")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <AiOutlineApartment />
                      <p className="pl-2">Jabatan</p>
                    </div>
                  </div>
                )}
                {(user.Otoritas.MStrukturOrganisasi ?? 0) !== 0 && (
                  <div
                    onClick={() => navigate("/master-struktur-organisasi")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <RiOrganizationChart />
                      <p className="pl-2">Struktur Organisasi</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MPayroll !== 0 && (
                  <div
                    onClick={() => navigate("/master-payroll")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <AiOutlineProfile />
                      <p className="pl-2">Payroll SO</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MPayrollHO !== 0 && (
                  <div
                    onClick={() => navigate("/master-payroll-ho")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <AiOutlineProfile />
                      <p className="pl-2">Payroll HO</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {Account && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="pl-5 text-white font-bold text-lg">Account</div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MMainAccount !== 0 && (
                  <div
                    onClick={() => navigate("/master-main-account")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <RiAccountCircleFill />
                      <p className="pl-2">General Account</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MSubAccount !== 0 && (
                  <div
                    onClick={() => navigate("/master-sub-account")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <RiAccountBoxFill />
                      <p className="pl-2">Main Account</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MSubAccount !== 0 && (
                  <div
                    onClick={() => navigate("/master-sub-group-account")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <MdSwitchAccount />
                      <p className="pl-2">Sub Account</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MDetailAccount !== 0 && (
                  <div
                    onClick={() => navigate("/master-detail-account")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <MdManageAccounts />
                      <p className="pl-2">Detail Account</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {Operational && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="pl-5 text-white font-bold text-lg">
                  Operational
                </div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MCustomer !== 0 && (
                  <div
                    onClick={() => navigate("/master-customer")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BsFillPersonBadgeFill />
                      <p className="pl-2">Customer</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MOum !== 0 && (
                  <div
                    onClick={() => navigate("/master-Uom")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BsCalculatorFill />
                      <p className="pl-2">UoM</p>
                    </div>
                  </div>
                )}
                {/* {
                user.Otoritas.MSubKegiatan !== 0 &&
                <div onClick={() => navigate('/master-sub-kegiatan')} className="w-full md:w-1/4 cursor-pointer">
                  <div style={{borderColor: Colors.primary}} className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded">
                    <RiCheckboxMultipleFill/>
                    <p className="pl-2">Sub Kegiatan</p>
                  </div>
                </div>
              }
              {
                user.Otoritas.MKegiatan !== 0 &&
                <div onClick={() => navigate('/master-kegiatan')} className="w-full md:w-1/4 cursor-pointer">
                  <div style={{borderColor: Colors.primary}} className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded">
                    <RiCheckboxFill/>
                    <p className="pl-2">Kegiatan</p>
                  </div>
                </div>
              } */}

                {user.Otoritas.MLocationUsed !== 0 && (
                  <div
                    onClick={() => navigate("/master-Location-Used")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaWarehouse />
                      <p className="pl-2">Location Used</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MLimbah !== 0 && (
                  <div
                    onClick={() => navigate("/master-haz-waste")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <GiNuclearWaste />
                      <p className="pl-2">Haz Waste</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MKemasan !== 0 && (
                  <div
                    onClick={() => navigate("/master-type-packaging")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <BiPackage />
                      <p className="pl-2">Type Of Packaging</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MGeneralServiceUnit !== 0 && (
                  <div
                    onClick={() => navigate("/master-general-service-unit")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaTruck />
                      <p className="pl-2">General Service Unit</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MRentalUnit !== 0 && (
                  <div
                    onClick={() => navigate("/master-rental-unit")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaTruck />
                      <p className="pl-2">Rental Unit</p>
                    </div>
                  </div>
                )}
                {/*{user.Otoritas.MKendaraan !== 0 && (*/}
                {/*    <div*/}
                {/*        onClick={() => navigate("/master-unit")}*/}
                {/*        className="w-full md:w-1/4 cursor-pointer"*/}
                {/*    >*/}
                {/*        <div*/}
                {/*            style={{borderColor: Colors.primary}}*/}
                {/*            className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"*/}
                {/*        >*/}
                {/*            <FaTruck/>*/}
                {/*            <p className="pl-2">Activity Unit</p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*)}*/}
                {user.Otoritas.MJetty !== 0 && (
                  <div
                    onClick={() => navigate("/master-jetty")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaBox />
                      <p className="pl-2">Jetty</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MRoom !== 0 && (
                  <div
                    onClick={() => navigate("/master-room")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaDoorClosed />
                      <p className="pl-2">Accoomodation/Room</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MMeals !== 0 && (
                  <div
                    onClick={() => navigate("/master-meals")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <MdFastfood />
                      <p className="pl-2">Meals</p>
                    </div>
                  </div>
                )}

                {user.Otoritas.MTypeOfClothing !== 0 && (
                  <div
                    onClick={() => navigate("/master-type-of-clothing")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaTshirt />
                      <p className="pl-2">Type Of Clothing</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MDestination !== 0 && (
                  <div
                    onClick={() => navigate("/master-Destination")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaMapSigns />
                      <p className="pl-2">Destination</p>
                    </div>
                  </div>
                )}

                {user.Otoritas.MFuel !== 0 && (
                  <div
                    onClick={() => navigate("/master-fuel")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaChargingStation />
                      <p className="pl-2">Fuel</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {ListActivity && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="px-5 text-white font-bold text-lg">
                  List Activity
                </div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MLabour !== 0 && (
                  <div
                    onClick={() => navigate("/master-manpower")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaPersonBooth />
                      <p className="pl-2">Manpower</p>
                    </div>
                  </div>
                )}
                {/* Gate memakai TOperationalMonitoring — modul halaman Quotation,
                    tempat daftar layanan ini dipakai. Sengaja BUKAN kolom otoritas
                    baru: GenerateAuthList menyebut kolom SOtoritas satu per satu,
                    jadi menambah kolom berarti migrasi yang wajib naik sebelum
                    backend — kalau terlewat, semua login gagal. */}
                {user.Otoritas.TOperationalMonitoring !== 0 && (
                  <div
                    onClick={() => navigate("/master-port-service")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaWater />
                      <p className="pl-2">Port Service</p>
                    </div>
                  </div>
                )}
                {/* Gate sama dengan Port Service (TOperationalMonitoring) — daftar
                    ini juga dipakai di halaman Quotation. */}
                {user.Otoritas.TOperationalMonitoring !== 0 && (
                  <div
                    onClick={() => navigate("/master-general-service-item")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaBoxes />
                      <p className="pl-2">Item General Service</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MWasteManagement !== 0 && (
                  <div
                    onClick={() => navigate("/master-waste-management")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaWater />
                      <p className="pl-2">Waste Management Services</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MCargoCarryingUnit !== 0 && (
                  <div
                    onClick={() => navigate("/master-cargo-carrying-unit")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaDropbox />
                      <p className="pl-2">Cargo Carrying Unit</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MAreaRental !== 0 && (
                  <div
                    onClick={() => navigate("/master-area-rental")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaTruckLoading />
                      <p className="pl-2">Area Rental</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MRental !== 0 && (
                  <div
                    onClick={() => navigate("/master-rental")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaTruckMoving />
                      <p className="pl-2">Rental</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {Inventory && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="px-5 text-white font-bold text-lg">
                  Procurment
                </div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MSupplier !== 0 && (
                  <div
                    onClick={() => navigate("/master/supplier")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaTruck />
                      <p className="pl-2">Supplier</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.UserPC !== 0 && (
                  <div
                    onClick={() => navigate("/master/user-pc")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaLaptop />
                      <p className="pl-2">User PC</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MFranco !== 0 && (
                  <div
                    onClick={() => navigate("/master/franco")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaPaperclip />
                      <p className="pl-2">Franco</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {Inventory && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="px-5 text-white font-bold text-lg">Gudang</div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                {user.Otoritas.MSatuan !== 0 && (
                  <div
                    onClick={() => navigate("/master-satuan")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <GiInjustice />
                      <p className="pl-2">Satuan</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MKelompok !== 0 && (
                  <div
                    onClick={() => navigate("/master/kelompok")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaBoxes />
                      <p className="pl-2">Kelompok</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MBarang !== 0 && (
                  <div
                    onClick={() => navigate("/master/Barang")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaBox />
                      <p className="pl-2">Barang</p>
                    </div>
                  </div>
                )}
                {user.Otoritas.MActivity !== 0 && (
                  <div
                    onClick={() => navigate("/master/activity")}
                    className="w-full md:w-1/4 cursor-pointer"
                  >
                    <div
                      style={{ borderColor: Colors.primary }}
                      className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                    >
                      <FaRunning />
                      <p className="pl-2">Master Activity</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {Equipment && (
          <div className="w-full px-4 my-4 ">
            <div
              style={{ borderColor: Colors.primary }}
              className="flex flex-col border rounded"
            >
              <div
                style={{ background: Colors.primary }}
                className="relative w-full py-2"
              >
                <div className="px-5 text-white font-bold text-lg">
                  Equipment
                </div>
              </div>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div
                  onClick={() => navigate("/master-jenis-petugas")}
                  className="w-full md:w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <BiWalk />
                    <p className="pl-2">Jenis Petugas</p>
                  </div>
                </div>
                {/* <div
                  onClick={() => navigate("/master-activity-equipment")}
                  className="w-full md:w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <FaTruck />
                    <p className="pl-2">Activity</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MasterPage;
